module.exports = __webpack_public_path__ + "img/about_03.8ae94605.png";